// A cleared rich-text editor leaves "<p><br></p>", which is truthy but shows nothing.
export function isBlankHtml(html) {
  if (html === undefined || html === null) return true;
  const str = String(html);
  if (/<(img|video|audio|iframe|embed|object|hr|svg|canvas)\b/i.test(str)) return false;
  return (
    str
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;|&#160;|&#xa0;/gi, " ")
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .trim().length === 0
  );
}
